import { Colors } from '@factorialco/deprecated-design-system'
import { ProjectManagementSerializedProjectCostChartPoint } from 'generated/resources/graphql'

import { formatGraphTimeTitle } from 'modules/project_management/lib/formatChartComponents'

export type BreakdownTransformedDataId = 'fixed_cost' | 'labor_cost' | 'spending_cost'

export type BreakdownTransformedData = {
  id: BreakdownTransformedDataId
  label: string
  max: number
  min: number
  data: BreakdownGraphData[]
  color: Colors
}

export type BreakdownGraphData = {
  x: number
  y: number
  title: string
}

type GetCostBreakdownTransformedDataParams = {
  data: ProjectManagementSerializedProjectCostChartPoint[]
  id: BreakdownTransformedDataId
  label: string
  color: Colors
  selectedFrequency: string
}

export const getCostBreakdownTransformedData = ({
  data,
  id,
  label,
  color,
  selectedFrequency,
}: GetCostBreakdownTransformedDataParams): BreakdownTransformedData => {
  const transformedData = data.map((item, index) => {
    return {
      x: index,
      y: item.costCents ? item.costCents / 100 : 0,
      title: index !== 0 ? formatGraphTimeTitle(item.year, item.timeSlot, selectedFrequency) : '',
    }
  })

  const registeredData: BreakdownTransformedData = {
    id,
    label,
    min: transformedData.at(0)?.y || 0,
    max: transformedData.at(-1)?.y || 0,
    data: transformedData,
    color,
  }

  return registeredData
}
